import React, { useState, useEffect } from "react";
import { X, ShoppingCart, Plus, Minus, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import axios from "axios";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { baseurl, imageUrl } from "../Baseurl";
import noproduct from "../component/img/product_not_found.jpeg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import CartCheckout from "./VisitorProduct/CartCheckout";

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const cust_id = localStorage.getItem("cust_id");
  const navigate = useNavigate(); // Initialize useNavigate


  const fetchCartItems = () => {
    axios
      .get(`${baseurl}FetchCartItems/${cust_id}`)
      .then((response) => {
        setCartItems(response.data.cartItems || []); // Ensure cartItems is always an array
      })
      .catch((error) => console.error("Error fetching cart data", error));
  };

  // Fetch items on component mount
  useEffect(() => {
    fetchCartItems();
  }, []);

  // Update quantity in the cart
  const updateQuantity = (cart_id, listing_id, change) => {
    const requestData = {
      cust_id,
      cart_id,  // Include row ID
      listing_id,
      change,   // Either +1 or -1
    };

    console.log("📤 Sending request data:", requestData); // Debugging log

    axios
      .post(`${baseurl}UpdateCartItemQuantityByCartId`, requestData)
      .then((response) => {
        console.log("✅ Response received:", response.data); // Debugging log
        fetchCartItems(); // Refresh cart after updating
      })
      .catch((error) => {
        console.error("❌ Error updating quantity", error);

        if (error.response && error.response.data && error.response.data.error) {
          Swal.fire({
            icon: "error",
            title: "Stock Issue",
            text: error.response.data.error,
            confirmButtonColor: "#d33",
          });
        }
      });
  };

  

  // Handle increment quantity
  const handleIncrement = (cart_id, listing_id) => {
    updateQuantity(cart_id, listing_id, +1);
  };
  
  const handleDecrement = (cart_id, listing_id, currentQuantity) => {
    if (currentQuantity > 1) {
      updateQuantity(cart_id, listing_id, -1);
    }
  };
  

  // Handle item deletion
  const handleDelete = async (cart_id) => {
    if (!cart_id) return;

    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      await axios.delete(`${baseurl}deleteCartItem/${cart_id}`);
      Swal.fire("Deleted!", "Your item has been deleted.", "success");
      fetchCartItems();
    } catch (error) {
      console.error("Error deleting item:", error);
      Swal.fire("Error!", "Failed to delete item. Please try again.", "error");
    }
  };



  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };



  return (
    <>
      <VisitorNavbar />
      <div className="container py-3">
        <h4 className="hesd mb-4 text-start">Items In Cart</h4>
        <div className="row">
          {/* Cart Items List */}
          <div className="col-md-8">
            {cartItems.length > 0 ? (
              cartItems.map((item, index) => (
                <div key={index} className="mb-2 crdpdr">
                  <div className="row">
                    <div className="col-md-1 col-3">
                      <img
                        src={
                          item.image
                            ? `${imageUrl}listing/${item.image}`
                            : noproduct
                        }
                        alt={item.name}
                        className="cart-item-img me-3"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "fill",
                        }}
                      />
                    </div>
                    <div className="col-md-10 col-9 px-3">
                      <div className="cart-item-details flex-grow-1">
                        <div className="text-start">
                          <h5 className="mb-1 ttl90 text-start">
                            {item.title}
                          </h5>
                          <p className="mb-1">
                            <span className="pric">
                              {/* {item.currency === "USD" ? "$" : "₹"}  */}
                              
                              {convertPrice(item.price)}
                              
                              {/* {item.price}  */}
                            </span>

                            <span className="pric">
                              &nbsp;+ {item.gst} % Gst
                            </span>

                            <span className="pric">
                            &nbsp; = &nbsp;
                            {/* {item.currency === "USD" ? "$" : "₹"} {item.price_with_gst} */}
                            {convertPrice(item.price_with_gst)}
                            </span>


                          </p>

                          <div className="d-flex justify-content-between">
                            {/* Quantity controls */}
                            <div className="quantity-controls">
  <button
    className="btn btn-sm btn-outline-secondary me-2"
    onClick={() =>
      handleDecrement(item.cart_id, item.listing_id, item.quantity)
    }
    disabled={item.quantity <= 1}
  >
    <Minus size={14} />
  </button>
  <span className="mx-3">{item.quantity}</span>
  <button
    className="btn btn-sm btn-outline-secondary ms-2"
    onClick={() => handleIncrement(item.cart_id, item.listing_id)}
  >
    <Plus size={14} />
  </button>
</div>


                            <div>
                              <button
                                className="btn btn-danger btn-sm hide-on-desktop"
                                onClick={() => handleDelete(item.cart_id)}
                              >
                                <Trash2 size={18} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1 col-12 text-end hide-on-mobile">
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item.cart_id)}
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="alert alert-warning text-center">
                <ShoppingCart size={40} className="mb-2" />
                <p>Your cart is empty!</p>
              </div>
            )}
          </div>

        
          {/* Price Summary */}
<div className="col-md-4">


<CartCheckout cartItems = {cartItems}/>


  
</div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default Cart;
